import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CreationProjetService } from '../creation-projet.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BroadcastService } from 'app/broadcast.service';
import { MessageNotification } from 'app/modules/models/messageNotification.type';
import { catchError, interval, Subject, Subscription, switchMap, takeUntil } from 'rxjs';

@Component({
  selector: 'app-redirection-pop-up',
  templateUrl: './redirection-pop-up.component.html',
  styleUrls: ['./redirection-pop-up.component.scss']
})
export class RedirectionPopUpComponent implements OnInit, OnDestroy {
  isSaved = false;
  isExtracted = false;
  isUploading: boolean;
  draftProgressPercent: number | null = null;
  draftProgressMessage: string | null = null;
  private stopPolling$ = new Subject<void>();
  private draftProgressSubscription?: Subscription;
  private hasRedirectStarted = false;
  project: any;

  constructor(private router: Router,
    private readonly _snackBar: MatSnackBar,
    private _creationProjetService: CreationProjetService,
    private readonly _broadcastService: BroadcastService,
    public dialogRef: MatDialogRef<RedirectionPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      id: string;
      waitForDraftProcessing?: boolean;
      refreshAfterProcessing?: boolean;
    }


  ) { }

  ngOnInit(): void {
    if (this.data.waitForDraftProcessing) {
      this.draftProgressSubscription = this._broadcastService.documentDraftProgress$.subscribe(notification => {
        this.handleDocumentDraftProgressNotification(notification);
      });
    } else {
      this.startExtraction(this.data.id);
    }
  }

  ngOnDestroy(): void {
    this.stopPolling();
    this.draftProgressSubscription?.unsubscribe();
  }

  // saveToDatabase() {
  //   this._creationProjetService.depotProjectFinancement(
  //     this.data.company.id,
  //     this.data.partnerId,
  //     this.data.formData,
  //     this.data.mandateId,
  //     this.data.partnerName,
  //     this.data.mandateName
  //   ).subscribe({
  //     next: res => {
  //       this.project = res;
  //       this._snackBar.open('Projet créé avec succès', null, { duration: 2000, panelClass: 'accent-snackbar' });
  //       this.isSaved = true;

  //     },
  //     error: err => {
  //       this._snackBar.open('Une erreur est survenue lors de la creation du projet', null, { duration: 2000, panelClass: 'accent-snackbar' });
  //     },
  //   });
  // }

  startExtraction(projet_Id) {
    interval(3000) // every 3 seconds
      .pipe(
        takeUntil(this.stopPolling$), // stop if told
        switchMap(() =>
          this._creationProjetService.checkIfProjectExists(projet_Id)
            .pipe(
              catchError(err => {
                this._snackBar.open(
                  'Une erreur est survenue lors de la vérification du projet',
                  undefined,
                  { duration: 2000, panelClass: 'accent-snackbar' }
                );
                this.isExtracted = false;
                throw err; // rethrow to stop polling on error, or use of(false) if you want to continue
              })
            )
        )
      )
      .subscribe(exists => {
        if (exists) {
          this.isExtracted = true;
          this.stopPolling(); // stop polling once done
          this.redirectAfterExtractionDone();
        }
      });
  }

  private handleDocumentDraftProgressNotification(notification: MessageNotification): void {
    try {
      const content = notification?.content ? JSON.parse(notification.content) : null;
      if (!content) return;

      const projectId = content?.ProjectId || content?.projectId || null;
      const message = content?.message ?? content?.Message ?? null;
      const progress = Number(content?.progress ?? content?.Progress ?? null);

      if (projectId && projectId === this.data.id && !isNaN(progress)) {
        this.draftProgressPercent = Math.max(0, Math.min(100, Math.round(progress)));
        this.draftProgressMessage = message ? String(message) : null;

        if (this.draftProgressPercent === 100) {
          this.isExtracted = true;
          this.stopPolling();
          this.redirectAfterExtractionDone();
        }
      }
    } catch (e) {
      console.error('Failed to parse draft progress notification', e, notification?.content);
    }
  }

  stopPolling() {
    if (!this.stopPolling$.closed) {
      this.stopPolling$.next();
      this.stopPolling$.complete();
    }
  }

  //redirect without waiting to the main project list
  redirectWithoutWaiting() {
    // Close the popup and redirect
    this.stopPolling(); // optional: stop polling immediately
    localStorage.setItem('selectedDossierIndex', "7");
    this.router.navigate(['/partner-dossier-project']); // Adjust route accordingly
    this.dialogRef.close(); // Close the dialog
  }

  // redirect after getting the extraction done
  redirectAfterExtractionDone() {
    if (this.hasRedirectStarted) {
      return;
    }

    this.hasRedirectStarted = true;
    setTimeout(() => {
      this.router.navigate(['/fiche-projet', this.data.id], {
        state: {
          refreshAfterProcessing: !!this.data.refreshAfterProcessing || !!this.data.waitForDraftProcessing
        }
      });
      this.dialogRef.close();
    }, 3000);
  }

}
